.verticalMargin {
  margin: 20px 0;
}
